'use client'
import Image from 'next/image';
import SvgArrow from '@/public/svg/Arrow';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { Link as LocaleLink } from '@/app/i18n/navigation';

const Footer = () => {
  const t = useTranslations('Header');

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-light pt-16 pb-8 px-6 md:px-12 relative overflow-hidden" id="footer">
      <div className="">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center mb-16">
          <div className="flex flex-col space-y-4 text-[#064E3B] text-xl font-semibold">
            <a href="#why_kidoor" className="hover:opacity-70 transition-opacity">{t('why_kidoor')}</a>
            <a href="#categories" className="hover:opacity-70 transition-opacity">{t('categories')}</a>
            <a href="#for_who" className="hover:opacity-70 transition-opacity">{t('for_who')}</a>
            <a href="#values" className="hover:opacity-70 transition-opacity">{t('values')}</a>
            <LocaleLink href="/classes-services" className="hover:opacity-70 transition-opacity">{t('classes_services')}</LocaleLink>
            <LocaleLink href="/blog" className="hover:opacity-70 transition-opacity">{t('blog')}</LocaleLink>
            <LocaleLink href="/contact-us" className="hover:opacity-70 transition-opacity">{t('contact_us')}</LocaleLink>
          </div>
          <div className="flex flex-col items-center justify-center space-y-8">
            <div className="flex items-center gap-2">
              <div className="w-50 h-10 relative">
                <Image src="/images/logo.png" alt="Kidoor Icon" fill className="object-contain" />
              </div>
            </div>

            <div className="relative flex flex-col md:flex-row items-center gap-6">
                <div className="w-48 h-48 rounded-[16px] overflow-hidden shadow-sm relative z-10">
                  <Image src="/images/9_kidoor_footer.webp" alt="Mother and child" fill className="object-cover" />
                </div>
                 <div className="p-3">
                    <Image src="/images/meta.png" alt="Kidoor: Meta Icon" width={50} height={50} className="object-contain" />
                 </div>
            </div>
            <div className="relative flex flex-col md:flex-row items-center gap-6">
                 <div className="p-3">
                  <Link href='https://www.instagram.com/kidoor_app/' target='_blank'>
                    <Image src="/images/ig.png" alt="Kidoor: Instagram Icon" width={50} height={50} className="object-contain" />
                  </Link>
                 </div>
                <div className="w-48 h-48 rounded-[16px] overflow-hidden shadow-sm relative z-10">
                  <Image src="/images/10_kidoor_footer.webp" alt="Child playing with blocks" fill className="object-cover" />
                </div>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-end space-y-2 text-[#064E3B] text-right">
            <p className="text-2xl font-bold">+355 68 8008 822</p>
            <p className="text-md">contact@kidoor.com</p>
            <p className="text-md">Rr. Elbasanit, Tirane, Albania</p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-end text-[#064E3B]/60 text-sm">
          <div className="mb-4 md:mb-0">
            <p>© {new Date().getFullYear()}{"  "} {t('rights_reserved')} Kidoor</p>
            <a href="https://primalt.com" className="font-bold text-[#064E3B]" target='_blank'>{t('powered_by')} Primalt.com</a>
          </div>

          <div className="mt-4 md:mt-0 text-center md:text-right">
            <button 
              onClick={scrollToTop}
              aria-label='scroll-top'
              className="bg-[#FDE68A] pb-1 px-1 rounded-lg text-[#064E3B] hover:bg-[#FACC15] transition-colors"
            >
              <SvgArrow />
            </button>
            <p className="font-bold text-[#064E3B]">Kidoor.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;